//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

//* Utils imports
import { QUERY_KEYS, queryInvalidator } from "@/utils/query-client";
import { uploadFile } from "@/services/uploadService";

type UploadReceiptParams = {
  file: File;
  saleId: string;
  onProgress?: (progress: number) => void;
};

async function uploadSaleReceipt({ file, saleId, onProgress }: UploadReceiptParams) {
  // Keeping uploadService here as it likely handles FormData complexity
  // But wrapping it in the standalone function pattern
  const result = await uploadFile(
    file,
    {
      upload_origin: "SALES_RECEIPT",
      params: {
        saleId,
      },
    },
    "/sales/upload",
    onProgress
  );
  return result.path;
}

export function useUploadSaleReceipt() {
  return useMutation({
    mutationFn: uploadSaleReceipt,
    onSuccess: async (_, variables) => {
      await queryInvalidator([
        [QUERY_KEYS.SALES.ALL],
        [QUERY_KEYS.SALES.SINGLE, variables.saleId],
      ]);
      toast.success("Comprovante enviado com sucesso!");
    },
  });
}
